import LayoutSimulacao from '~componentes/LayoutSimulacao.vue';
import SimulacaoPagamento from './SimulacaoPagamento.vue';

export default {
  path: '/simulacao',
  component: LayoutSimulacao,
  children: [
    {
      path: '',
      component: SimulacaoPagamento,
      name: 'simulacao.pagamento',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/simulacao-pagamento/rotas.js